import { render, staticRenderFns } from "./ChatView.vue?vue&type=template&id=4b0ba72d&scoped=true&"
import script from "./chatview.js?vue&type=script&lang=js&"
export * from "./chatview.js?vue&type=script&lang=js&"
import style0 from "./chatview.scss?vue&type=style&index=0&id=4b0ba72d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0ba72d",
  null
  
)

export default component.exports